import { Phone, Clock, MessageCircle, Navigation } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";
import { whatsappLink, telLink, mapsLink } from "@/lib/contact";
import SectionHeading from "@/components/SectionHeading";
import { Reveal } from "@/components/Reveal";

export default function LocationSection() {
  const settings = useSettings();
  const mapQuery = encodeURIComponent(`${settings?.address || "Meguiar's İzmit"} Kocaeli`);
  const mapsEmbed = `https://www.google.com/maps?q=${mapQuery}&z=14&output=embed`;

  return (
    <section data-testid="location-section" className="bg-black py-24 sm:py-32">
      <div className="container-x grid items-stretch gap-10 lg:grid-cols-2">
        <Reveal>
          <SectionHeading number="08" overline="Lokasyon" title="Kocaeli İzmit'te yanınızdayız" subtitle="Aracınızı bize getirin, en doğru koruma planını birlikte belirleyelim." />
          <div className="mt-10 space-y-3">
            <a href={telLink(settings)} className="group flex items-center gap-4 border border-white/10 bg-white/[0.02] p-5 transition-colors hover:border-gold/40">
              <span className="flex h-11 w-11 items-center justify-center border border-gold/30 bg-gold/10 text-gold"><Phone className="h-5 w-5" /></span>
              <span><span className="block font-oswald text-[11px] uppercase tracking-[0.2em] text-neutral-500">Telefon</span><span className="font-semibold text-white">{settings?.phone}</span></span>
            </a>
            <a href={whatsappLink(settings)} target="_blank" rel="noopener noreferrer" className="group flex items-center gap-4 border border-white/10 bg-white/[0.02] p-5 transition-colors hover:border-gold/40">
              <span className="flex h-11 w-11 items-center justify-center border border-gold/30 bg-gold/10 text-gold"><MessageCircle className="h-5 w-5" /></span>
              <span><span className="block font-oswald text-[11px] uppercase tracking-[0.2em] text-neutral-500">WhatsApp</span><span className="font-semibold text-white">Hemen yazın</span></span>
            </a>
            <div className="flex items-center gap-4 border border-white/10 bg-white/[0.02] p-5">
              <span className="flex h-11 w-11 items-center justify-center border border-gold/30 bg-gold/10 text-gold"><Clock className="h-5 w-5" /></span>
              <span><span className="block font-oswald text-[11px] uppercase tracking-[0.2em] text-neutral-500">Çalışma Saatleri</span><span className="font-semibold text-white">{settings?.working_hours}</span></span>
            </div>
            <a href={mapsLink(settings)} target="_blank" rel="noopener noreferrer" data-testid="location-directions" className="flex items-center justify-center gap-2 bg-gold px-6 py-4 font-oswald text-sm font-bold uppercase tracking-[0.12em] text-black transition-colors hover:bg-gold-300">
              <Navigation className="h-4 w-4" /> Yol Tarifi Al
            </a>
          </div>
        </Reveal>
        <Reveal delay={0.1} className="h-full">
          <div className="h-full min-h-[380px] overflow-hidden border border-white/10">
            <iframe
              title="Meguiar's İzmit Konum"
              src={mapsEmbed}
              className="h-full min-h-[380px] w-full grayscale-[0.4] contrast-[1.05]"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
